module.exports = __webpack_public_path__ + "static/media/web-development.28a13e7b.jpg";